import { Box, Text } from '@factorialco/deprecated-design-system'
import { RichTextDisplay } from '@factorialco/f0-react/dist/experimental'
import {
  ContractsEmployeesJobCatalogTreeFragment,
  ResourceFieldDataFragment,
  TaskDetailAffecteeReferenceContractFragment,
  TaskDetailContractContextlessPoliciesFragment,
  TaskDetailCustomFieldsContextlessPoliciesFragment,
  TaskDetailJobCatalogContextlessPoliciesFragment,
  ValueDataFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { WorkflowOwner } from 'modules/tasks/hooks/useMaterializedTaskItem'

import Attachments from 'modules/tasks/components/TaskDetails/Attachments'
import { Comments } from 'modules/tasks/components/TaskDetails/Comments'
import DataCollection from 'modules/tasks/components/TaskDetails/DataCollection'
import DocumentSignatures from 'modules/tasks/components/TaskDetails/DocumentSignatures'
import UploadDocumentsTypeAttachments from 'modules/tasks/components/TaskDetails/UploadDocumentsTypeAttachments'
import { TaskDetail } from 'modules/tasks/components/TaskElement/useTaskDetail'
import { TaskFile } from 'modules/tasks/hooks/useGetTaskFiles'

import './index.styles.css'
interface Props {
  loadingFiles?: boolean
  task: TaskDetail
  files?: TaskFile[]
  owner: WorkflowOwner | undefined
  canSeePersonalInfo: boolean
  canEditPersonalInfo: boolean
  canEmployeeManageAnyEmployeeFolder: boolean
  customResourceFieldsData: ResourceFieldDataFragment[]
  customValuesData: ValueDataFragment[]
  hasDevTimeTrackingWorkableDaysDefinition?: boolean
  hasTimeTrackingAnnualisationDailyValue?: boolean
  referenceContract?: TaskDetailAffecteeReferenceContractFragment | null
  jobCatalogContextlessPolicies: TaskDetailJobCatalogContextlessPoliciesFragment | undefined
  hasPayrollBundle: boolean
  contractContextlessPolicies: TaskDetailContractContextlessPoliciesFragment | undefined
  customFieldsContextlessPolicies: TaskDetailCustomFieldsContextlessPoliciesFragment | undefined
  jobCatalogTreeFeatureEnabled?: boolean
  jobCatalogTrees?: ContractsEmployeesJobCatalogTreeFragment[]
  hideComments?: boolean
}

const Content = ({
  task,
  files = [],
  loadingFiles = false,
  owner,
  canSeePersonalInfo,
  canEditPersonalInfo,
  canEmployeeManageAnyEmployeeFolder,
  customResourceFieldsData,
  customValuesData,
  hasDevTimeTrackingWorkableDaysDefinition,
  hasTimeTrackingAnnualisationDailyValue,
  referenceContract,
  jobCatalogContextlessPolicies,
  hasPayrollBundle,
  contractContextlessPolicies,
  customFieldsContextlessPolicies,
  jobCatalogTreeFeatureEnabled,
  jobCatalogTrees,
  hideComments,
}: Props) => {
  const content = task.content

  const superTask = () => {
    const type = 'type' in task ? task.type : null
    switch (type) {
      case 'sign_documents':
      case 'send_document_template':
        return <DocumentSignatures task={task} owner={owner} />
      case 'upload_document':
        return (
          <UploadDocumentsTypeAttachments
            task={task}
            canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
          />
        )
      case 'data_collection':
        return (
          <DataCollection
            task={task}
            canSeePersonalInfo={canSeePersonalInfo}
            canEditPersonalInfo={canEditPersonalInfo}
            canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
            referenceContract={referenceContract}
            customResourceFieldsData={customResourceFieldsData}
            customValuesData={customValuesData}
            hasDevTimeTrackingWorkableDaysDefinition={hasDevTimeTrackingWorkableDaysDefinition}
            hasTimeTrackingAnnualisationDailyValue={hasTimeTrackingAnnualisationDailyValue}
            jobCatalogContextlessPolicies={jobCatalogContextlessPolicies}
            hasPayrollBundle={hasPayrollBundle}
            contractContextlessPolicies={contractContextlessPolicies}
            customFieldsContextlessPolicies={customFieldsContextlessPolicies}
            jobCatalogTreeFeatureEnabled={jobCatalogTreeFeatureEnabled}
            jobCatalogTrees={jobCatalogTrees}
          />
        )
      default:
        return null
    }
  }

  return (
    <Box gap="s40">
      {!!content && (
        <Box gap="s16" width="full" className={'Content_textWidth'}>
          <>
            <Text.Normal weight="semibold" color="grey1000">
              {i18n.t('tasks.labels.content')}
            </Text.Normal>
            <RichTextDisplay content={content} />
          </>
        </Box>
      )}
      <Attachments files={files} loadingFiles={loadingFiles} />
      {superTask()}
      {!hideComments && <Comments taskId={task.id} />}
    </Box>
  )
}

export default Content
